import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Alert,
  Card,
  CardContent,
  useTheme,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  ArrowForward as ArrowForwardIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      py: 4,
      display: 'flex',
      alignItems: 'center'
    }}>
      <Container maxWidth="sm">
        <Paper 
          elevation={24} 
          sx={{ 
            p: 6, 
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            textAlign: 'center'
          }}
        >
          <Box sx={{ mb: 4 }}>
            <CheckCircleIcon 
              sx={{ 
                fontSize: 80, 
                color: 'success.main',
                mb: 2
              }} 
            />
            <Typography 
              variant="h3" 
              component="h1" 
              gutterBottom 
              sx={{ 
                fontWeight: 800,
                background: 'linear-gradient(45deg, #4CAF50 30%, #8BC34A 90%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 2
              }}
            >
              Registration Successful!
            </Typography>
            
            <Typography 
              variant="h6" 
              color="text.secondary" 
              paragraph
              sx={{ mb: 3 }}
            >
              Thank you for registering with VerTechie. Your account is being verified and you will receive a confirmation email shortly.
            </Typography>

            <Alert severity="success" sx={{ mb: 4 }}>
              <Typography variant="body2">
                <strong>Next Steps:</strong><br />
                • Check your email for verification instructions<br />
                • Complete document verification if required<br />
                • Wait for account approval (usually within 24-48 hours)
              </Typography>
            </Alert>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<EmailIcon />}
                onClick={() => window.open('mailto:support@vertechie.com')}
                sx={{
                  background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                  borderRadius: 2,
                  px: 3,
                  py: 1.5
                }}
              >
                Contact Support
              </Button>
              
              <Button
                variant="outlined"
                size="large"
                endIcon={<ArrowForwardIcon />}
                onClick={() => navigate('/')}
                sx={{
                  borderColor: 'primary.main',
                  borderRadius: 2,
                  px: 3,
                  py: 1.5
                }}
              >
                Back to Home
              </Button>
            </Box>

            <Box sx={{ mt: 4 }}>
              <Typography variant="body2" color="text.secondary">
                <strong>Need Help?</strong> Contact us at support@vertechie.com or call +1 (307) 254-9378
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default SignupSuccess;








